const initMenuMobile = () => {
    const hamburger = document.querySelector('.btn-hamburger'),
        header = document.querySelector('.header--page'),
        toggles = document.querySelectorAll('.main-menu__toggle'),
        toggleClass = 'main-menu__toggle--active',
        toggleSubClass = 'main-submenu--active'

    let isHamburgerActive = false

    hamburger.addEventListener('click', function (event) {
        console.log('hamburger')
        isHamburgerActive = !isHamburgerActive
        isHamburgerActive == true ? header.classList.add('header--active') : header.classList.remove('header--active')
        hamburger.setAttribute('aria-expanded', isHamburgerActive)

        if (isHamburgerActive == false) {
            const activeToggle = document.querySelector('.' + toggleClass),
                activeSubmenu = document.querySelector('.' + toggleSubClass)

            if (activeToggle !== null && activeSubmenu !== null) {
                toggleSlideUp(activeToggle, activeSubmenu)
            }
        }
    })

    const toggleSlideDown = (toggle, submenu) => {
        toggle.classList.add(toggleClass)
        submenu.classList.add(toggleSubClass)
        submenu.style.height = 'auto'

        var height = submenu.clientHeight + 'px'

        submenu.style.height = '0px'

        setTimeout(function () {
            submenu.style.height = height
        }, 0)
    }

    const toggleSlideUp = (toggle, submenu) => {
        toggle.classList.remove(toggleClass)
        submenu.style.height = '0px'

        submenu.addEventListener(
            'transitionend',
            function () {
                submenu.classList.remove(toggleSubClass)
            },
            {
                once: true,
            }
        )
    }

    for (const toggle of toggles) {
        toggle.addEventListener('click', function (event) {
            const activeToggle = document.querySelector('.' + toggleClass),
                activeSubmenu = document.querySelector('.' + toggleSubClass),
                toggleSibling = toggle.nextElementSibling

            if (activeToggle !== null && activeSubmenu !== null) {
                toggleSlideUp(activeToggle, activeSubmenu)
            }

            if (!toggleSibling.classList.contains(toggleSubClass)) {
                toggleSlideDown(toggle, toggleSibling)
            } else {
                toggleSlideUp(toggle, toggleSibling)
            }
        })
    }
}
